export const brandStats = [
  { number: '30+', label: 'Customers Across Geographies' },
  { number: '7,000+', label: 'Users on Key Programs' },
  { number: '65%', label: 'Cost Reduction Achieved' },
  { number: '2X', label: 'YoY Growth Since FY2023' },
];

export const architectureSystems = [
  {
    code: 'AZ',
    title: 'Complete Analysis',
    subtitle: '',
    engine: 'Business Outcomes',
    description: 'Verb form - what we do, end to end.',
    services: ['Infrastructure & Security', 'Cloud Architecture', 'Network Assessment', 'Security Audit'],
  },
  {
    code: 'OS',
    title: 'Outcomes Driven',
    subtitle: '',
    engine: 'Optimised Execution',
    description: 'Objective focused - every action delivers measurable value.',
    services: ['Managed Services', 'Strategic Advisory', 'Adoption Excellence', 'System Integration'],
  },
  {
    code: 'IS',
    title: 'Intelligence System',
    subtitle: '',
    engine: 'Continuous Growth via Technology',
    description: 'Hybrid model - Man and Machine, fused for impact.',
    services: ['AI & Machine Learning', 'Data Analytics', 'Automation', 'Computer Vision'],
  },
];

export const practiceAreas = [
  {
    id: 'M1',
    name: 'Modernize',
    tagline: 'Migration to Modern Workspace - 10 services',
    description:
      'We migrate systems on schedule for successful adoption. Every migration is preceded by a thorough assessment that maps fit, validates approach, and brings every cutover to a successful close.',
    services: [
      'Email Migration',
      'Storage Migration',
      'Data Migration',
      'Application Migration',
      'Infrastructure Migration',
      'Cloud Migration',
      'Network Migration',
      'Legacy System Migration',
      'Database Migration',
      'Virtualization Migration',
    ],
    alignedTo: 'AZ',
  },
  {
    id: 'M2',
    name: 'Mobilize & Magnify',
    tagline: 'Workspace + Man and Machine - 20 services',
    description:
      'A unified practice spanning two dimensions of the modern operating model. Mobilize delivers the secure distributed workspace. Magnify delivers human-guided intelligent automation. Together they form an integrated practice.',
    services: [],
    subAreas: [
      {
        name: 'Mobilize',
        services: [
          'Cloud PC',
          'Single Sign-On',
          'Cloud Storage & File Sharing',
          'Communication & Conferencing',
          'Project Management & Collaboration',
          'Note-taking & Task Management',
          'Multi-Factor Authentication',
          'Time Tracking',
          'Security & VPN',
          'Backup & Disaster Recovery',
        ],
      },
      {
        name: 'Magnify',
        services: [
          'Data Annotation & Big Data',
          'Data Analysis, BI & Automation',
          'ID Scanner',
          'Barcode Scanner',
          'Document Scanner',
          'Meter ID Scanner',
          'Computer Vision',
          'Data Reading & ERP Integration',
          'AI Design & Agent Deployment',
          'AI Research & Consulting',
        ],
      },
    ],
    alignedTo: 'OS + IS',
  },
  {
    id: 'M3',
    name: 'Manage Success',
    tagline: 'Managed Services - 12 services',
    description:
      'A one-stop solution for the technology operating model. We coordinate across OEMs and distributors to deliver solutions that keep running long after implementation.',
    services: [
      'Hoster & Managed Services',
      'Unified Support',
      'Cloud Services',
      'Software Asset Management',
      'Reselling & Consultations',
      'ISV Modernisation',
      'Move to Modern Architectures',
      'Cloud & License Optimisation',
      'System Integration',
      'Data & Analytics',
      'LMS & Knowledge Portal',
      'Adoption & Change Management',
    ],
    alignedTo: 'OS + IS',
  },
];

export const leadershipTeam = [
  {
    name: 'Ramadurai Radhakrishnan',
    role: 'Founder & Director',
    roleTag: 'FOUNDER & DIRECTOR',
    tagline: '26+ years of technology. One mission - make it work for your business.',
    location: 'India · UAE',
    bio: 'Since founding Azosis in 2010, Ram has led the company from a bold idea into a multinational firm serving clients from Bengaluru to San Francisco, Dubai to APAC. His consulting-first approach pairs deep domain expertise with the engineering capability to build, deploy, and operate technology that delivers measurable business value.',
    quote: 'A very well-rounded professional with excellent communication skills and an amazing positive outlook - a go-getter whose technical abilities and soft skills take his team to greater heights.',
    quoteSource: 'LinkedIn peer recommendation',
    photoUrl: '/assets/Ram.webp',
  },
  {
    name: 'Lalita Narayanan',
    role: 'Co-Founder & Director',
    roleTag: 'CO-FOUNDER & DIRECTOR',
    tagline: '16+ years building the models that technology partnerships actually deliver.',
    location: 'India · UAE',
    bio: 'Lalita is the operational force that scaled Azosis from a bold idea into a trusted multinational business. Co-architect of the systems that drove sustained revenue growth, she translates strategy into execution with precision. Her delivery-focused, customer-obsessed philosophy is the operational backbone of every engagement.',
    quote: 'Delivery-focused and customer-obsessed - Lalita is the operational backbone of Azosis, translating strategy into execution with precision.',
    quoteSource: 'Azosis Technologies, 2026',
    photoUrl: '/assets/Lalitha.webp',
  },
  {
    name: 'Usha Narasimhulu',
    role: 'Director',
    roleTag: 'DIRECTOR',
    tagline: '12+ years turning strategy into outcomes - in the classroom, and now in the enterprise.',
    location: 'India',
    bio: 'Usha specializes in project management, business operations, and people management. Her rare dual background brings a people-first philosophy to every engagement. She goes beyond managing projects, building the people and processes that make every project succeed.',
    quote: 'Usha brings a rare combination of academic rigor and operational sharpness - she goes beyond managing projects, building the people and processes that make every project succeed.',
    quoteSource: 'Azosis Technologies, 2026',
    photoUrl: '/assets/Usha.webp',
  },
];

export const globalOffices = [
  {
    region: 'INDIA',
    name: 'India',
    entity: 'Azosis Technologies Private Limited',
    location: 'Bangalore',
    role: 'Bangalore Engineering Hub',
    web: 'azosis.in',
    flag: 'https://flagcdn.com/w80/in.png',
  },
  {
    region: 'USA',
    name: 'USA',
    entity: 'Azosis Technologies LLC',
    location: 'Wilmington, Delaware',
    role: 'Delaware Technology Hub',
    web: 'azosis.us',
    flag: 'https://flagcdn.com/w80/us.png',
  },
  {
    region: 'UAE',
    name: 'UAE',
    entity: 'Azosis Technologies LLC',
    location: 'Dubai',
    role: 'Dubai EMEA & GCC Gateway',
    web: 'azosis.ae',
    flag: 'https://flagcdn.com/w80/ae.png',
  },
  {
    region: 'SINGAPORE',
    name: 'Singapore',
    entity: 'Azosis Technologies PTE LTD',
    location: 'Singapore',
    role: 'Singapore APAC Gateway',
    web: 'azosis.sg',
    flag: 'https://flagcdn.com/w80/sg.png',
  },
];

export const partnerEcosystem = [
  'Microsoft', 'AWS', 'Google Cloud', 'Snowflake', 'Citrix',
];

export const engagementPaths = [
  {
    step: '01',
    title: 'Discovery Workshop',
    duration: '1–2 days, no cost',
    description:
      'Day 1 produces a documented scope. Day 2 finalises the solution approach and demo. For clients exploring.',
    for: 'Clients Exploring',
  },
  {
    step: '02',
    title: 'Proof of Concept',
    duration: '2–4 weeks, fixed scope',
    description:
      'Smallest viable demonstration of the solution against your real environment. For clients validating.',
    for: 'Clients Validating',
  },
  {
    step: '03',
    title: 'Managed Engagement',
    duration: '3+ months, end-to-end',
    description:
      'Full delivery with implementation, change management, and Manage Success practice. For clients committing.',
    for: 'Clients Committing',
  },
];

export const logoOptions = [
  {
    id: 1,
    name: 'Geometric Modern',
    description: 'Wordmark AZOSIS with custom geometric sans-serif. The letter O replaced with a hexagon shape symbolizing the three systems converging. Gold accent line beneath.',
    style: 'geometric',
  },
  {
    id: 2,
    name: 'Tech Minimalist',
    description: 'Clean sans-serif with interconnected A and Z forming an abstract circuit pattern. Monochrome with optional gold highlight. Emphasizes the technology backbone.',
    style: 'minimalist',
  },
  {
    id: 3,
    name: 'Dynamic Symbol',
    description: 'Abstract A icon formed by three converging arrows suggesting the AZ-OS-IS systems. Paired with clean wordmark. Gradient gold-to-bronze fill for warmth.',
    style: 'dynamic',
  },
  {
    id: 4,
    name: 'Trinity Lockup',
    description: 'AZ · OS · IS arranged as three stacked blocks with the multiplication symbol between them, resolving into AZOSIS. The equation becomes the logo itself.',
    style: 'trinity',
  },
  {
    id: 5,
    name: 'Signature Variant',
    description: 'Elegant serif wordmark with the signature line "Three Systems · Core Engines · One Signature" integrated beneath. Premium, established feel.',
    style: 'signature',
  },
  {
    id: 6,
    name: 'Monogram Mark',
    description: 'A stylized monogram combining A, Z, O, S, I, S into a single geometric mark. Works at any scale from app icon to billboard. Clean and instantly recognizable.',
    style: 'monogram',
  },
];